var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('feather-icon',{staticClass:"cursor-pointer ml-4 mr-5 mt-1 text-white",attrs:{"icon":"GlobeIcon","badge":"Geo"},on:{"click":_vm.show}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }